import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { ComponentDesignLoadedState } from '../slices/componentDesignsSlice';
import { SaveState, SaveStatus } from '../slices/saveSlice';

function anyCommittedComponentDesignHasStatus(
  saveState: SaveState,
  componentDesignsLoadedState: { readonly [componentDesignGuid: string]: ComponentDesignLoadedState },
  status: SaveStatus,
) {
  return Object.entries(componentDesignsLoadedState).some(
    ([componentDesignGuid, loadedState]) => loadedState.committed && saveState[componentDesignGuid] === status,
  );
}

export const getSaveStatus = createSelector(
  (state: RootState) => state.save,
  (state: RootState) => state.componentDesigns.loadedState,
  (saveState, componentDesignsLoadedState) =>
    anyCommittedComponentDesignHasStatus(saveState, componentDesignsLoadedState, 'error')
      ? ('error' as const)
      : anyCommittedComponentDesignHasStatus(saveState, componentDesignsLoadedState, 'saving')
        ? ('saving' as const)
        : ('saved' as const),
);
